var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.tabs},_vm._l((_vm.tabs),function({id, name}){return _c('div',{key:id,class:[_vm.$style.tabs__item,{[_vm.$style.tabs__item_active]: _vm.activeTab === id}],on:{"click":function($event){return _vm.change(id)}}},[_vm._v(" "+_vm._s(name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }